/* input-options.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./input-options.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useCallback, useMemo, useState } from 'react';
import PrimitiveSVGIcon from '@atlaskit/icon/svg';
import { fg } from '@atlaskit/platform-feature-flags';
var optionStyles = {
  default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
  focused: "_bfhk1dpa _16qsgkog _112e5u6v",
  disabled: "_syaz15gi"
};

// state of the parent option

// the primary color represents the outer or background element
var getPrimaryColor = function getPrimaryColor(_ref) {
  var isActive = _ref.isActive,
    isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected;
  if (isDisabled) {
    return "var(--ds-background-disabled, #17171708)";
  } else if (isSelected && isActive) {
    return "var(--ds-background-selected-bold-pressed, #123263)";
  } else if (isActive) {
    return "var(--ds-background-selected-pressed, #8FB8F6)";
  } else if (isFocused && isSelected) {
    return "var(--ds-background-selected-bold-hovered, #1558BC)";
  } else if (isFocused) {
    return "var(--ds-surface, #FFFFFF)";
  } else if (isSelected) {
    return "var(--ds-background-selected-bold, #1868DB)";
  }
  return "var(--ds-background-neutral, #0515240F)";
};

// the secondary color represents the radio dot or checkmark
var getSecondaryColor = function getSecondaryColor(_ref2) {
  var isDisabled = _ref2.isDisabled,
    isSelected = _ref2.isSelected;
  if (isDisabled && isSelected) {
    return "var(--ds-text-disabled, #080F214A)";
  } else if (!isSelected) {
    return 'transparent';
  }
  return "var(--ds-surface, #FFFFFF)";
};
var iconStyles = {
  inherit: "_1u9j1r31 _1gqp1r31",
  default: "_1u9jrsbi _1gqprsbi"
};
var baseIconStyles = null;
var baseOptionStyles = null;
var ControlOption = function ControlOption(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  var onMouseDown = useCallback(function () {
    return setIsActive(true);
  }, []);
  var onMouseUp = useCallback(function () {
    return setIsActive(false);
  }, []);
  var Icon = props.Icon,
    children = props.children,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    cx = props.cx,
    className = props.className,
    isDisabled = props.isDisabled,
    isSelected = props.isSelected,
    isFocused = props.isFocused;
  var classNames = useMemo(function () {
    return cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className);
  }, [cx, isDisabled, isFocused, isSelected, className]);
  return /*#__PURE__*/React.createElement("div", _extends({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className: ax([optionStyles.default, isFocused && optionStyles.focused, isDisabled && optionStyles.disabled, classNames]),
    ref: innerRef,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp
    // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
    ,
    onMouseLeave: onMouseUp
  }, innerProps), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9", isSelected || isActive || isDisabled ? iconStyles.inherit : iconStyles.default])
  }, !!Icon ? /*#__PURE__*/React.createElement(Icon, {
    label: "",
    primaryColor: getPrimaryColor({
      isDisabled: isDisabled,
      isSelected: isSelected,
      isFocused: isFocused,
      isActive: isActive
    }),
    secondaryColor: getSecondaryColor({
      isDisabled: isDisabled,
      isSelected: isSelected
    }),
    isFacadeDisabled: true
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: ax(["_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"])
  }, children));
};
var svgStyles = null;
var newCheckboxIconPath = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  x: "5.5",
  y: "5.5",
  width: "13",
  height: "13",
  rx: "1.5",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
  fill: "inherit"
}));
var NewCheckboxIcon = function NewCheckboxIcon(props) {
  if (fg('platform-custom-icon-migration')) {
    var primaryColor = props.primaryColor,
      secondaryColor = props.secondaryColor,
      label = props.label;
    return /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      style: {
        color: primaryColor,
        fill: secondaryColor
      },
      "aria-label": label ? label : undefined,
      role: label ? 'img' : 'presentation',
      className: ax(["_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"])
    }, newCheckboxIconPath);
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props, @atlaskit/design-system/no-custom-icons
    React.createElement(PrimitiveSVGIcon, props, newCheckboxIconPath)
  );
};
var newRadioIconPath = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "6.75",
  fill: "currentColor",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "3",
  fill: "inherit"
}));
var NewRadioIcon = function NewRadioIcon(props) {
  if (fg('platform-custom-icon-migration')) {
    var primaryColor = props.primaryColor,
      secondaryColor = props.secondaryColor,
      label = props.label;
    return /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      style: {
        color: primaryColor,
        fill: secondaryColor
      },
      "aria-label": label ? label : undefined,
      role: label ? 'img' : 'presentation',
      className: ax(["_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"])
    }, newRadioIconPath);
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props, @atlaskit/design-system/no-custom-icons
    React.createElement(PrimitiveSVGIcon, props, newRadioIconPath)
  );
};

/**
 * __Checkbox option__
 */
export var CheckboxOption = function CheckboxOption(props) {
  return /*#__PURE__*/React.createElement(ControlOption, _extends({
    Icon: NewCheckboxIcon
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, props));
};

/**
 * __Radio option__
 */
export var RadioOption = function RadioOption(props) {
  return (
    /*#__PURE__*/
    // TODO https://product-fabric.atlassian.net/browse/DSP-20769
    React.createElement(ControlOption, _extends({
      Icon: NewRadioIcon
      // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    }, props))
  );
};